import { Injectable } from '@angular/core';
import {IdexService} from './idex.service';
import { Subject } from 'rxjs';

@Injectable()
export class DataService {
  public senderObject: any;

  /** Routes that make up the task area; the list filter is kept while the user stays inside it. */
  private static readonly TASK_AREA = ['/tasks', '/signdoc', '/create-task'];

  private static readonly TASK_FILTER_KEY = 'taskFilterType';

  /**
   * Date range chosen on the task list. Kept in sessionStorage rather than in memory because
   * opening a task force-reloads the page (sign-task.component.ts), which would otherwise wipe
   * the selection before the user gets back to the list.
   */
  get taskFilterType(): string {
    return sessionStorage.getItem(DataService.TASK_FILTER_KEY);
  }

  set taskFilterType(value: string) {
    if (value) {
      sessionStorage.setItem(DataService.TASK_FILTER_KEY, value);
    } else {
      sessionStorage.removeItem(DataService.TASK_FILTER_KEY);
    }
  }

  constructor(protected service: IdexService) { }

  /** Called on every navigation: leaving the task area drops the list back to its default. */
  forgetTaskFilterOutsideTaskArea(url: string) {
    const path = url.split('?')[0];
    const insideTaskArea = DataService.TASK_AREA
      .some(route => path === route || path.startsWith(route + '/'));

    if (!insideTaskArea) {
      this.taskFilterType = null;
    }
  }

  /**
   * Called for the first navigation of an app load, before the list is created. Landing on the
   * task list means a real page load, which starts at the default; landing anywhere else in the
   * task area is the forced reload a task does, so the selection is kept for the way back.
   */
  forgetTaskFilterOnFreshTaskList(url: string) {
    const path = url.split('?')[0];

    if (path === '/tasks' || path.startsWith('/tasks/')) {
      this.taskFilterType = null;
    }
  }

  getSenderList(fromDate: string, toDate: string) {
    this.service.get('/task/listSender?fromDate=' + fromDate + '&toDate=' + toDate)
      .subscribe(data => {
        if (data !== undefined && data.length !== 0) {
          this.senderObject = {
            senderList: data,
            isExpand: true
          };
        } else {
          this.senderObject = {
            senderList: [],
            isExpand: false
          };
        }
      }, error => {
        this.senderObject = {
          senderList: [],
          isExpand: false
        };
      });
  }
}
